export default __webpack_public_path__ + "static/media/familyroom.345a3a8e.jpg";